import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ROUTE_TRANSITION } from '../../../app.animation';
import { LoginService } from '../../../services/api/login.service';
import { FormBuilder, FormGroup } from '@angular/forms';

@Component({
    selector: 'vr-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'],
    animations: [...ROUTE_TRANSITION],
    host: { '[@routeTransition]': '' }
})
export class LoginComponent implements OnInit {
    form: FormGroup;
    user: any;
    password: string;
    errMsg = '';
    id: null;
    public showPassword = false;

    constructor(
        private router: Router,
        private loginService: LoginService,
        private fb: FormBuilder,
    ) {
    }

    ngOnInit() {
        sessionStorage.removeItem('login');
        /*    this.form = this.fb.group({
                mobile: [this.mobile || ''],
            });*/
        // reset login status
        this.loginService.logout(false);
    }
    keyPresss(event: any) {
        // const pattern = /[a-zA-Z0-9-]/;

        // let inputChar = String.fromCharCode(event.charCode);
        // if (event.keyCode != 8 && !pattern.test(inputChar)) {
        //     event.preventDefault();
        // }
    }
    login() {
        this.loginService.getToken(this.user, this.password)
            .subscribe(resp => {
                if (resp.success === false) {
                    this.errMsg = 'Username or password is incorrect';
                    return;
                }
                /*     if (resp.length > 0 && resp.user.webAllowed === true) {
                          this.errMsg = 'You are not allowed to Login';
                          return;
                      }*/
                this.errMsg = '';
                this.router.navigate(['/']);
            },
                errResponse => {
                    switch (errResponse.status) {
                        case 401:
                            this.errMsg = 'Username or password is incorrect';
                            break;
                        case 404:
                            this.errMsg = 'Service not found';
                            break;
                        case 408:
                            this.errMsg = 'Request Time out';
                            break;
                        case 500:
                            this.errMsg = 'Internal Server Error';
                            break;
                        default:
                            this.errMsg = 'Server Error';
                    }
                }
            );
    }

    togglePasswordVisibility(param: boolean) {
        this.showPassword = param;
    }

    getLogin(id: any) {

    }

}
